import { createFileRoute, Outlet } from '@tanstack/react-router'
import { redirectIfAuthenticated } from '../utils/auth-guards'

export const Route = createFileRoute('/_unauthenticated')({
  beforeLoad: redirectIfAuthenticated,
  component: Outlet
})
